/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedPageBreadcrumbs_itemSearch = {
    readonly pageType: string | null;
    readonly appliedFilters: ReadonlyArray<{
        readonly name: string | null;
        readonly values: ReadonlyArray<{
            readonly urlLabel: string | null;
        } | null> | null;
    } | null> | null;
    readonly breadcrumbs: ReadonlyArray<{
        readonly displayName: string | null;
        readonly path: string | null;
    } | null> | null;
    readonly " $refType": "SbSharedPageBreadcrumbs_itemSearch";
};
export type SbSharedPageBreadcrumbs_itemSearch$data = SbSharedPageBreadcrumbs_itemSearch;
export type SbSharedPageBreadcrumbs_itemSearch$key = {
    readonly " $data"?: SbSharedPageBreadcrumbs_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedPageBreadcrumbs_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedPageBreadcrumbs_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "pageType",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "appliedFilters",
      "storageKey": null,
      "args": null,
      "concreteType": "SearchBrowseParsedParam",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "values",
          "storageKey": null,
          "args": null,
          "concreteType": "SearchBrowseParsedParamValue",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "urlLabel",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "breadcrumbs",
      "storageKey": null,
      "args": null,
      "concreteType": "SearchBrowseBreadcrumbs",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "displayName",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "path",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = 'b322e0d4880a592d40fdab51cd9fe948';
export default node;
